<template>
  <search-comp @onSearch="onSearchFilter" @onReset="onResetFilter">
    <div class="das-form-container das-form-group">
      <el-row :gutter="16" class="das-form-row">
        <el-col :span="8" class="das-form-col">
          <div class="das-form-input">
            <div class="label">
              {{ 'Từ khóa' }}
            </div>
            <input
              v-model="searchParams.info"
              type="text"
              placeholder="Từ khóa"
            />
          </div>
        </el-col>
        <el-col :span="8" class="das-form-col">
          <div class="das-form-input">
            <div class="label">
              {{ 'Trạng thái đặt' }}
            </div>
            <el-select v-model="selectedBookingStatus">
              <el-option
                v-for="(option, index) in reservationStatusOptions"
                :key="index"
                :value="option.value"
                :label="option.label"
              >
              </el-option>
            </el-select>
            <!-- <Multiselect
              v-model="selectedBookingStatus"
              :options="reservationStatusOptions"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder="Trạng thái"
              label="label"
              track-by="label"
            >
              <template
                slot="selection"
                slot-scope="{ values, search, isOpen }"
              >
                <span
                  v-if="values.length"
                  v-show="!isOpen"
                  class="multiselect__single"
                  >{{ values.map(item => item.label).join(', ') }}
                </span>
              </template>
            </Multiselect> -->
          </div>
        </el-col>
        <el-col :span="8" class="das-form-col">
          <div class="das-form-input">
            <div class="label">
              {{ 'Ngày' }}
            </div>
            <CalendarSelect
              v-model="searchParams.date"
              mode="date"
            ></CalendarSelect>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="16" class="das-form-row">
        <el-col :span="8" class="das-form-col">
          <div class="das-form-input">
            <div class="label">
              {{ 'Hạng phòng' }}
            </div>
            <select-with-search-table
              style="width: auto; flex-grow: 1"
              index-field="id"
              :search-fields="['id', 'code', 'name']"
              :selected-index-field-value="searchParams.roomTypeId"
              :value="searchParams.roomTypeId"
              :rows="roomTypeRows"
              :columns="roomTypeCols"
              :is-remove-btn="true"
              @selectionChanged="onSelectRoomType"
            >
              <template v-slot:value="{ selectedValue: selectedData }">
                <div>
                  <span>
                    {{
                      `${selectedData?.code || ''} - ${
                        selectedData?.name || ''
                      }`
                    }}
                  </span>
                </div>
              </template>
            </select-with-search-table>
          </div>
        </el-col>
        <el-col :span="8" class="das-form-col">
          <div class="das-form-input">
            <div class="label">
              {{ 'Dịch vụ đặc biệt' }}
            </div>
            <select-with-search-table
              style="width: auto; flex-grow: 1"
              index-field="id"
              :search-fields="['id', 'code', 'desc']"
              :selected-index-field-value="searchParams.specialServiceList"
              :value="searchParams.specialServiceList"
              :rows="specSvcRows"
              :columns="specSvcCols"
              :is-remove-btn="true"
              :multiple="true"
              @selectionChanged="onSelectSpecSvc"
            >
              <template v-slot:value="{ selectedValue: selectedData }">
                <span v-for="data in selectedData" :key="data.code"
                  >{{ data?.code }},
                </span>
              </template>
            </select-with-search-table>
          </div>
        </el-col>
        <el-col :span="8" class="das-form-input">
          <div class="label">
            {{ 'Trạng thái đặt' }}
          </div>
          <div
            style="
              background: #f0f0f5;
              padding: 0 8px;
              margin: 0;
              height: 32px;
              display: flex;
              align-items: center;
              border-radius: 5px;
              justify-content: space-between;
            "
          >
            <div class="checkbox-wrap">
              <input
                id="reservation-status[isInternal]"
                v-model="searchParams.isInternal"
                type="checkbox"
              />
              <label
                style="color: #606266; font-size: 14px"
                for="reservation-status[isInternal]"
                >{{ 'Nội bộ' }}</label
              >
            </div>
            <div class="checkbox-wrap">
              <input
                id="reservation-status[isFree]"
                v-model="searchParams.isFree"
                type="checkbox"
              />
              <label
                style="color: #606266; font-size: 14px"
                for="reservation-status[isFree]"
                >{{ 'Miễn phí' }}</label
              >
            </div>
            <div class="checkbox-wrap">
              <input
                id="reservation-status[isOneDayBooking]"
                v-model="searchParams.isOneDayBooking"
                type="checkbox"
              />
              <label
                style="color: #606266; font-size: 14px"
                for="reservation-status[isOneDayBooking]"
                >{{ 'Ở trong ngày' }}</label
              >
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </search-comp>
</template>
<script>
import { getRoomLevel, getSpecialService } from '@/api/reception/common'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
// import Multiselect from 'vue-multiselect'
export default {
  components: { CalendarSelect },
  data() {
    return {
      roomTypeRows: [],
      roomTypeCols: [
        { headerName: 'ID', field: 'id', tooltipField: 'id' },
        { headerName: 'Mã', field: 'code', tooltipField: 'code' },
        {
          headerName: 'Tên',
          field: 'name',
          tooltipField: 'name'
        }
      ],
      specSvcRows: [],
      specSvcCols: [
        { headerName: 'ID', field: 'id', tooltipField: 'id' },
        { headerName: 'Mã', field: 'code', tooltipField: 'code' },
        {
          headerName: 'Mô tả',
          field: 'desc',
          tooltipField: 'desc'
        }
      ],
      reservationStatusOptions: [
        { label: 'Definite', value: 1 },
        { label: 'Tentative', value: 2 }
      ],
      createdByOptions: [],
      departmentOptions: [],
      selectedBookingStatus: [],
      searchParams: {
        // Row 1
        info: null,
        bookingStatus: [],
        date: this.$moment().format('YYYY-MM-DD'),
        specialServiceList: null,
        roomTypeId: null,
        isInternal: false,
        isFree: false,
        isOneDayBooking: false
      }
    }
  },
  watch: {
    selectedBookingStatus(value) {
      this.searchParams.bookingStatus = value?.map(item => item.value) || []
    }
  },
  mounted() {
    this.onSearchFilter()
  },
  async beforeMount() {
    await Promise.all([this.callGetSpecialService(), this.callGetRoomLevel()])
  },
  methods: {
    async callGetSpecialService() {
      let res = null
      try {
        res = await getSpecialService()
        if (res.is_error) {
          throw new Error(res)
        }
      } catch (error) {
        console.log(error)
        this.$message({
          message: 'Lỗi lấy dữ liệu!',
          type: 'error'
        })
      } finally {
        //
      }
      this.specSvcRows =
        res?.data.map(item => ({
          id: item.id,
          code: item.code,
          name: item.description
        })) || []
    },
    async callGetRoomLevel() {
      let res = null
      try {
        res = await getRoomLevel()
        if (res.is_error) {
          throw new Error(res)
        }
      } catch (error) {
        console.log(error)
        this.$message({
          message: 'Lỗi lấy dữ liệu!',
          type: 'error'
        })
      } finally {
        //
      }
      this.roomTypeRows = res?.data || []
    },
    onSelectRoomType(data) {
      this.searchParams.roomTypeId = data?.id || null
    },
    onSelectSpecSvc(data) {
      this.searchParams.specialServiceList = data?.map(item => item.id) || null
    },
    onSearchFilter() {
      this.$emit('onSearchFilter', this.searchParams)
    },
    onResetFilter() {
      this.$emit('onResetFilter', this.searchParams)
    }
  }
}
</script>
<style>
.das-form-group > * + * {
  margin-top: 16px;
}
</style>
